import React, { useEffect, useRef, useState } from 'react';
import OdButton from '../../OdButton/OdButton';
import './OdCategoryTab.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getHomePageProductsLoad } from '../../../../actionCreators/home';
import OdProductCard from '../OdProductCard/OdProductCard';
import Slider from 'react-slick';

function getTabByCatId(tabs, catId) {
  const tab = tabs.find(tab => tab.catId === catId);
  return tab || {};
}

const OdCategoryTab = ({ data, device = 'desktop' }) => {
  const homePageProductsData = useSelector(state => state.home.homePageProducts.data);
  const disptach = useDispatch();
  const [slideIndex, setSlideIndex] = useState(0);
  const sliderRef = useRef(null);

  const { tabs } = data;
  const [currentTab, setCurrentTab] = useState('');

  useEffect(() => {
    if (tabs?.length > 0) {
      setCurrentTab(tabs[0].catId);
    }
  }, [tabs]);

  useEffect(() => {
    if (currentTab) {
      disptach(getHomePageProductsLoad(currentTab));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTab]);

  const PrevArrowButton = () => {
    if (slideIndex === 0) return null;
    return (
      <button
        aria-label="Click here to see previous slide"
        style={{
          position: 'absolute',
          top: '40%',
          left: -10,
          transform: 'translate(-50%, -50%)',
          border: 'none',
          background: 'none',
        }}
      >
        <img
          alt="left"
          className="odcategorytab-body-slick-icon"
          src="https://static.lenskart.com/media/owndays/minified/prev.webp"
        />
      </button>
    );
  };

  const config = {
    arrows: true,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    slideIndex,
    centerPadding: '40px',
    afterChange: next => setSlideIndex(next),
    nextArrow: (
      <button aria-label="Click here to see next slide">
        <img
          alt="right"
          className="odcategorytab-body-slick-icon"
          src="https://static.lenskart.com/media/owndays/minified/next.webp"
        />
      </button>
    ),
    prevArrow: <PrevArrowButton />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 727,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  if (tabs && Array.isArray(tabs) && tabs.length > 0 && homePageProductsData?.length > 0) {
    return (
      <div className="odcategorytab">
        <div className="odcategorytab-head">
          {tabs.map((tab, index) => (
            <div
              key={index}
              className={`odcategorytab-head-bar ${
                currentTab === tab.catId ? 'odcategorytab-head-active' : ''
              }`}
              onClick={() => setCurrentTab(tab.catId)}
            >
              {tab.title}
            </div>
          ))}
        </div>
        <div className="odcategorytab-body">
          <Slider ref={sliderRef} {...config}>
            {homePageProductsData?.length > 0 &&
              homePageProductsData.map((product, index) => (
                <OdProductCard
                  key={index}
                  currentTab={currentTab}
                  index={index}
                  product={product}
                />
              ))}
          </Slider>
        </div>
        <div className="odcategorytab-footer">
          <OdButton
            href={getTabByCatId(tabs, currentTab).ctaLink}
            label={getTabByCatId(tabs, currentTab).cta}
          />
        </div>
        {device === 'mobile' ? <div className="odcategorytab__mobileBorder" /> : null}
      </div>
    );
  }

  return null;
};

export default OdCategoryTab;
